import API from "api/axiosInstance";
import { setIsLoading, setListDepartemen, setStatus } from "./index";

export const fetchListDepartemen = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/departemen");
    dispatch(setIsLoading(false));
    dispatch(setListDepartemen(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};
